export function extractCouponsFromBasket(basketResponse) {
    const coupons = []
    const couponMap = new Map()
    const couponIdMap = new Map()
    const couponErrorMap = new Map()
    const couponStatusMap = new Map()

    if (!basketResponse) return coupons

    const appliedCouponCodes = new Set()
    const allCouponCodes = new Set()

    if (basketResponse.couponItems && Array.isArray(basketResponse.couponItems)) {
        basketResponse.couponItems
            .filter((item) => item.valid === true)
            .forEach((item) => {
                allCouponCodes.add(item.code)
                couponIdMap.set(item.code, item.couponItemId)

                if (item.c_errorMessage) {
                    couponErrorMap.set(item.code, item.c_errorMessage)
                }

                if (item.statusCode) {
                    couponStatusMap.set(item.code, item.statusCode)
                }

                if (item.statusCode === 'applied') {
                    appliedCouponCodes.add(item.code)
                }
            })
    }

    if (
        basketResponse.orderPriceAdjustments &&
        Array.isArray(basketResponse.orderPriceAdjustments)
    ) {
        basketResponse.orderPriceAdjustments.forEach((adjustment) => {
            if (adjustment.couponCode && appliedCouponCodes.has(adjustment.couponCode)) {
                const discountValue = Math.abs(adjustment.price || 0)
                couponMap.set(
                    adjustment.couponCode,
                    (couponMap.get(adjustment.couponCode) || 0) + discountValue
                )
            }
        })
    }

    if (basketResponse.productItems && Array.isArray(basketResponse.productItems)) {
        basketResponse.productItems.forEach((product) => {
            if (product.priceAdjustments && Array.isArray(product.priceAdjustments)) {
                product.priceAdjustments.forEach((adjustment) => {
                    if (adjustment.couponCode && appliedCouponCodes.has(adjustment.couponCode)) {
                        const discountValue = Math.abs(adjustment.price || 0)
                        couponMap.set(
                            adjustment.couponCode,
                            (couponMap.get(adjustment.couponCode) || 0) + discountValue
                        )
                    }
                })
            }
        })
    }

    allCouponCodes.forEach((code) => {
        const discountValue = couponMap.get(code) || 0
        const errorMessage = couponErrorMap.get(code)
        const statusCode = couponStatusMap.get(code)

        coupons.push({
            couponCode: code,
            couponValue: discountValue > 0 ? -discountValue : 0,
            couponItemId: couponIdMap.get(code),
            errorMessage: errorMessage || null,
            statusCode: statusCode || null,
            isApplied: appliedCouponCodes.has(code)
        })
    })

    return coupons
}
